import * as yup from "yup";

export const customerTierDetailSchema = yup.object().shape({
  invoiceCategoryId: yup.string().required().label("Invoice Category"),
  discountRate: yup.number().default(0).required().label("Discount Rate"),
});
